import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import IconOffer from 'app/components/customSvgs/IconOffer';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SeekerOffersDrawer from './SeekerOffersDrawer';

const SeekerOffersBanner = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Clickable Banner */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2, py: 1, borderTop: '1px solid var(--color_ddd)', borderBottom: '1px solid var(--color_ddd)', cursor: 'pointer' }}
        onClick={() => setOpen(true)}
        id="SeekerOffersBanner"
        className="displayNone" // Rather than FF, we will use displayNone to hide Offer Banner while we work on this feature
      >
        {/* Left side: Icon + Text */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconOffer htmlColor="#ef8d34" />
          <Typography variant="body1" sx={{ color: '#06c' }}>Offers and Promotions</Typography>
        </Stack>

        {/* Right side: Arrow Icon */}
        <ArrowForwardIosIcon sx={{ fontSize: 16 }} />
      </Stack>

      {/* Drawer Component */}
      <SeekerOffersDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default SeekerOffersBanner;
